/**
 * AUTO-GIFT — multi-paires
 * Ajoute automatiquement un cadeau quand son produit déclencheur est dans le panier.
 * La quantité du cadeau suit celle du produit déclencheur (2 bottes => 2 cartes cadeaux),
 * sauf si la paire déclare un maxQty (le pistolet reste unique : 2 bottes => 1 pistolet).
 * Respecte les choix de l'utilisateur (refus du cadeau).
 */
(function () {
  'use strict';

  // ====== CONFIG : ajoute autant de paires que tu veux ici ======
  // maxQty (optionnel) : plafond de quantité pour le cadeau.
  var PAIRS = [
    {
      id: 'belt-extension',
      triggerProductId: 10401283211606,   // Ceinture lombaire
      giftVariantId: 53312290029910       // Extension UltraConfort
    },
    {
      id: 'boots-massagegun',
      triggerProductId: 10839944102230,   // Bottes pressothérapie (v1)
      giftVariantId: 54228413612374,      // Pistolet PulseRecover
      maxQty: 1                           // un seul pistolet, même pour 2 paires
    },
    {
      id: 'boots2-massagegun',
      triggerProductId: 11140369514838,   // Bottes récupération musculaire (v2)
      giftVariantId: 54228413612374,      // Pistolet PulseRecover (même cadeau)
      maxQty: 1
    },
    {
      id: 'boots-giftcard',
      triggerProductId: 10839944102230,   // Bottes pressothérapie (v1)
      giftVariantId: 55119015805270       // Carte-cadeau 20€ (1 par paire)
    },
    {
      id: 'boots2-giftcard',
      triggerProductId: 11140369514838,   // Bottes récupération musculaire (v2)
      giftVariantId: 55119015805270       // Carte-cadeau 20€ (1 par paire)
    }
  ];

  var GIFT_PROPERTY_KEY = '_gift';
  var GIFT_PROPERTY_VAL = 'true';

  // Plusieurs paires peuvent partager le même cadeau : on les regroupe pour
  // qu'elles ne se battent pas sur la quantité de la même ligne panier.
  // Le plafond du groupe est le plus strict de ceux de ses paires.
  var GROUPS = (function () {
    var byVariant = {};
    var out = [];
    PAIRS.forEach(function (pair) {
      var group = byVariant[pair.giftVariantId];
      if (!group) {
        group = byVariant[pair.giftVariantId] = {
          giftVariantId: pair.giftVariantId,
          pairs: [],
          maxQty: 0
        };
        out.push(group);
      }
      group.pairs.push(pair);
      if (pair.maxQty > 0) {
        group.maxQty = group.maxQty > 0 ? Math.min(group.maxQty, pair.maxQty) : pair.maxQty;
      }
    });
    return out;
  })();

  var nativeFetch = window.fetch.bind(window);
  var prevState = {};    // { pair.id: { triggered: bool, giftCount: int } }
  var pending = null;
  var syncing = false;

  PAIRS.forEach(function (p) { prevState[p.id] = { triggered: null, giftCount: 0 }; });

  function log() { try { console.log.apply(console, ['[auto-gift]'].concat([].slice.call(arguments))); } catch (e) {} }

  function dismissKey(pair) { return 'autoGift.dismissed.' + pair.id; }
  function isDismissed(pair) { try { return sessionStorage.getItem(dismissKey(pair)) === '1'; } catch (e) { return false; } }
  function setDismissed(pair, v) {
    try { v ? sessionStorage.setItem(dismissKey(pair), '1') : sessionStorage.removeItem(dismissKey(pair)); } catch (e) {}
  }

  function getDrawerSectionId() {
    var el = document.querySelector('cart-drawer');
    return (el && el.dataset && el.dataset.sectionId) || null;
  }

  function getCart() {
    return nativeFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function findGifts(cart, giftVariantId) {
    var out = [];
    if (!cart || !cart.items) return out;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === giftVariantId) out.push(cart.items[i]);
    }
    return out;
  }

  function triggerQty(cart, pair) {
    var n = 0;
    if (!cart || !cart.items) return 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === pair.triggerProductId) n += cart.items[i].quantity;
    }
    return n;
  }

  function applyDrawer(sections, itemCount) {
    try {
      var sid = getDrawerSectionId();
      var drawer = document.querySelector('cart-drawer');
      if (sid && sections && sections[sid] && drawer) {
        var newDoc = new DOMParser().parseFromString(sections[sid], 'text/html');
        var newIn = newDoc.querySelector('.cart-drawer__inner');
        var oldIn = drawer.querySelector('.cart-drawer__inner');
        if (newIn && oldIn) oldIn.innerHTML = newIn.innerHTML;
        if (itemCount === 0) drawer.classList.add('cart-drawer--empty');
        else drawer.classList.remove('cart-drawer--empty');
      }
    } catch (e) { log('apply drawer err:', e); }

    try {
      if (itemCount != null) {
        var counters = document.querySelectorAll('cart-icon [data-ref="cart-count"]');
        for (var i = 0; i < counters.length; i++) counters[i].textContent = itemCount;
      }
    } catch (e) {}
  }

  function notifyDrawer(state) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { resource: {}, data: {
          source: 'auto-gift',
          itemCount: state && state.item_count,
          sections: state && state.sections
        }}
      }));
    } catch (e) {}
  }

  function addGiftRaw(giftVariantId, quantity) {
    var body = { items: [{ id: giftVariantId, quantity: quantity, properties: {} }] };
    body.items[0].properties[GIFT_PROPERTY_KEY] = GIFT_PROPERTY_VAL;
    var sid = getDrawerSectionId();
    if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
    return nativeFetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function changeRaw(key, qty) {
    var body = { id: key, quantity: qty };
    var sid = getDrawerSectionId();
    if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
    return nativeFetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // ====== LOGIQUE PRINCIPALE ======
  function handleSync(silent) {
    if (syncing) return Promise.resolve(null);
    syncing = true;

    return getCart().then(function (cart) {
      var actions = Promise.resolve(null);
      var lastState = null;

      GROUPS.forEach(function (group) {
        actions = actions.then(function () {
          var gifts = findGifts(cart, group.giftVariantId);
          var giftCount = gifts.length;
          var want = 0;

          group.pairs.forEach(function (pair) {
            var qty = triggerQty(cart, pair);
            var triggered = qty > 0;
            var prev = prevState[pair.id];

            if (!triggered && prev.triggered) setDismissed(pair, false);

            if (triggered && giftCount === 0 && prev.triggered && prev.giftCount > 0) {
              setDismissed(pair, true);
              log('Cadeau refusé [' + pair.id + ']');
            }

            prevState[pair.id] = { triggered: triggered, giftCount: giftCount };

            if (triggered && !isDismissed(pair)) want += qty;
          });

          // Plafond éventuel (ex : le pistolet reste à 1 même pour 2 paires).
          if (group.maxQty > 0 && want > group.maxQty) want = group.maxQty;

          if (want < 1) return null;

          if (giftCount > 1) {
            log('Dedup ' + giftCount + ' [variant ' + group.giftVariantId + ']');
            var withProp = gifts.filter(function (it) {
              return it.properties && (it.properties[GIFT_PROPERTY_KEY] === GIFT_PROPERTY_VAL || it.properties[GIFT_PROPERTY_KEY] === true);
            });
            var keep = withProp[0] || gifts[0];
            var toRemove = gifts.filter(function (it) { return it.key !== keep.key; });
            var p = Promise.resolve(null);
            toRemove.forEach(function (it) { p = p.then(function () { return changeRaw(it.key, 0); }); });
            p = p.then(function () { return changeRaw(keep.key, want); });
            return p.then(function (state) {
              if (state) { lastState = state; cart = state; }
            });
          }

          if (giftCount === 1 && gifts[0].quantity !== want) {
            return changeRaw(gifts[0].key, want).then(function (state) {
              if (state) { lastState = state; cart = state; }
            });
          }

          if (giftCount === 0) {
            log('Ajout cadeau x' + want + ' [variant ' + group.giftVariantId + ']');
            return addGiftRaw(group.giftVariantId, want).then(function (state) {
              group.pairs.forEach(function (pair) { prevState[pair.id].giftCount = 1; });
              if (state) { lastState = state; cart = state; }
            });
          }

          return null;
        });
      });

      return actions.then(function () {
        if (lastState) {
          applyDrawer(lastState.sections, lastState.item_count);
          if (!silent) notifyDrawer(lastState);
        }
      });
    }).catch(function (err) {
      log('sync err:', err);
    }).then(function () {
      syncing = false;
    });
  }

  function scheduleSync() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () { pending = null; handleSync(false); }, 100);
  }

  // ====== INTERCEPT FETCH ======
  window.fetch = function (input, init) {
    var url = '';
    try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
    var isCartMut = /\/cart\/(add|change|update|clear)(\.js)?($|\?)/.test(url);

    var p = nativeFetch(input, init);
    if (isCartMut) p.then(function () { scheduleSync(); }, function () {});
    return p;
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && /\/cart\/add/.test(form.action)) {
      setTimeout(scheduleSync, 250);
    }
  }, true);

  // ====== INIT ======
  function init() {
    getCart().then(function (cart) {
      var anyTriggered = false;
      GROUPS.forEach(function (group) {
        var giftCount = findGifts(cart, group.giftVariantId).length;
        group.pairs.forEach(function (pair) {
          var triggered = triggerQty(cart, pair) > 0;
          prevState[pair.id] = { triggered: triggered, giftCount: giftCount };
          if (!triggered) setDismissed(pair, false);
          if (triggered) anyTriggered = true;
        });
      });
      if (anyTriggered) handleSync(true);
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  log('initialisé (' + PAIRS.length + ' paires, ' + GROUPS.length + ' cadeaux)');
})();
